import { render, staticRenderFns } from "./multi-text-adder.vue?vue&type=template&id=5d35a648&scoped=true&"
import script from "./multi-text-adder.vue?vue&type=script&lang=js&"
export * from "./multi-text-adder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d35a648",
  null
  
)

export default component.exports